export default __webpack_public_path__ + "static/media/027-tag.f7737299.svg";